import { Mapper } from '../../../common/ddd';
import { SelfChallengeTargetStreakEntity } from '../../../core/domain/entities/challenge-target-result/self-challenge-target-streak.entity';
import { GetSelfMetricsInsightsChallengeTargetStreakResponseDto } from '../../../interface/dtos/challenge-insights/get-self-metrics-insights-challenge-target-sreak.response.dto';

export class SelfChallengeTargetStreakMapper
  implements
    Omit<
      Mapper<
        SelfChallengeTargetStreakEntity,
        GetSelfMetricsInsightsChallengeTargetStreakResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: SelfChallengeTargetStreakEntity
  ): GetSelfMetricsInsightsChallengeTargetStreakResponseDto {
    return SelfChallengeTargetStreakMapper.toResponse(entity);
  }
  static toResponse(
    entity: SelfChallengeTargetStreakEntity
  ): GetSelfMetricsInsightsChallengeTargetStreakResponseDto {
    return {
      value: entity.value,
      successTotal: entity.successTotal,
      total: entity.total,
    };
  }
}
